import { mergeStyleSets } from '@uifabric/merge-styles';
import theme from '../../theme.style';
import { pxToRem } from '../../utils';

export default mergeStyleSets({
  labelStyle: {
    display: 'block',
    color: theme.palette.neutralPrimary,
    marginBottom: pxToRem(8),
  },
  valueStyle: {
    color: theme.palette.neutralPrimary,
    fontWeight: 400,
  },
  negativeAmount: {
    color: theme.palette.accentError,
  },
  paymentSection: {
    selectors: {
      '& .ms-TextField-fieldGroup': {
        background: theme.palette.neutralWhite,
      },
    },
  },
  bold: {
    fontWeight: 'bold',
  },
  keyword: {
    display: 'inline-block',
    background: theme.palette.neutralLighter,
    color: theme.palette.neutralDark,
    fontSize: pxToRem(14),
    padding: `${pxToRem(2)} ${pxToRem(6)}`,
    fontWeight: 400,
    marginRight: pxToRem(6),
    marginBottom: pxToRem(6),
  },
  autoReverse: {
    top: '50%',
    paddingLeft: pxToRem(8),
  },
  attachments: {
    paddingTop: pxToRem(20),
  },
  uploader: {
    display: 'none',
  },
  moreOptions: {
    top: '50%',
  },
  addItem: {
    float: 'right',
  },
  addAdvanceGroup: {
    float: 'right',
    fontSize: pxToRem(15),
  },
  topPadding: {
    paddingTop: pxToRem(8),
  },
  sidePadding: {
    paddingLeft: `${pxToRem(8)} !important`,
    paddingRight: `${pxToRem(8)} !important`,
  },
  adjustmentName: {
    button: {
      height: pxToRem(24),
      marginTop: pxToRem(-5),
    },
  },
  fieldStackGrids: {
    marginTop: `${pxToRem(24)} !important`,
  },
  dateField: {
    width: pxToRem(200),
  },
  advanceBalanceStmtPeriod: {
    width: `${pxToRem(135)} !important`,
  },
  taxCode: {
    width: `${pxToRem(250)} !important`,
  },
  noBg: {
    background: 'none',
  },
  contractId: {
    marginTop: pxToRem(10),
    fontWeight: 400,
  },
  amountTextField: {
    selectors: {
      '&::-webkit-inner-spin-button, &::-webkit-outer-spin-button': {
        appearance: 'none',
        margin: 0,
      },
    },
  },
  royaltiesEarnedButtonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: pxToRem(12),
  },
  viewAdvanceGroup: {
    marginTop: pxToRem(24),
    fontSize: pxToRem(15),
    marginLeft: pxToRem(-150),
  },
  royaltiesAdjustmentsList: {
    overflowX: 'auto',
    zIndex: 10,
    '.ms-DetailsRow-cell': {
      overflow: 'visible',
    },
  },
  royaltiesEarnedColumn: {
    position: 'relative',
    backgroundColor: 'transparent',
    ':active': {
      backgroundColor: 'transparent',
    },
    ':hover': {
      backgroundColor: 'transparent',
    },
  },
  transparentBackground: {
    backgroundColor: 'transparent',
    ':active': {
      backgroundColor: 'transparent',
    },
    ':hover': {
      backgroundColor: 'transparent',
    },
  },
  attachmentDeleteIcon: {
    cursor: 'pointer',
    opacity: 0.85,
    ':hover': {
      opacity: 1,
    },
    color: theme.palette.neutralSecondary,
    selectors: {
      '.ms-Button-icon': {
        fontSize: pxToRem(12),
      },
    },
  },
  attachmentDeleteIconDisabled: {
    cursor: 'wait',
    ':hover': {
      opacity: 0.85,
    },
  },
  reverseCheck: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    border: 'none !important',
    '&.ms-Button.is-disabled': {
      backgroundColor: 'transparent',
    },
    ':disabled': {
      '.ms-Check::before': {
        background: theme.palette.neutralLight,
      },
    },
  },
});
